import { colors } from '../../../../../../constants/colors';

export const useStyles = (open: boolean) => ({
  icon: {
    color: colors.white,
    opacity: open ? 0.6 : 0,
    cursor: 'pointer',
  },
});
